import useLabels from "hooks/useLabels";
import { Ghost } from "lucide-react";

export const IncognitoModeBanner = () => {
  const [incognitoModeLabels] = useLabels("incognito-mode");
  const incognitoMode = incognitoModeLabels["incognito-mode"];
  const incognitoModeDescription =
    incognitoModeLabels["incognito-mode-description"];

  return (
    <div className="flex flex-col gap-2 bg-bg-faint py-2 px-4">
      <div className="flex items-center gap-3">
        <Ghost className="text-fg-base w-5 h-5" />
        <span className="sm-md">{incognitoMode}</span>
      </div>
      <p className="tiny-normal text-fg-muted">{incognitoModeDescription}</p>
    </div>
  );
};
